import React from "react";
import { Box } from "@mui/material";

const JawPage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Jaw"}
    </Box>
  );
};

export default JawPage;
